// @ts-check
import React, { useState, useCallback } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Button, ButtonProps } from '../Button'; // eslint-disable-line no-unused-vars
import { useTimeout } from 'preferral-ui/hooks/useTimeout';
import ClipboardCopyIcon from '@heroicons/react/solid/ClipboardCopyIcon';
import CheckIcon from '@heroicons/react/solid/CheckIcon';

/** @typedef {{
  text: string;
} & ButtonProps} CopyButtonProps */

/** @type { React.FC<CopyButtonProps> } */
export const CopyButton = (props) => {
  const {
    text,
    children,
    className = 'flex items-center',
    ...buttonProps
  } = props;
  const [copied, setCopied] = useState(false);
  const setTimeout = useTimeout();

  // const clearMessage = useCallback(() => {
  //   setTimeout(() => setCopied(false), 150);
  // }, [setTimeout, setCopied]);

  const handleCopyClick = useCallback(() => {
    setCopied(true);
    setTimeout(() => setCopied(false), 4000);
  }, [setTimeout, setCopied]);

  return (
    <CopyToClipboard text={text} onCopy={handleCopyClick}>
      <Button className={className} {...buttonProps}>
        {copied ? (
          <>
            <CheckIcon className="w-4 h-4 mr-2" />
            Copied!
          </>
        ) : (
          <>
            <ClipboardCopyIcon className="w-4 h-4 mr-2" />
            {children}
          </>
        )}
      </Button>
    </CopyToClipboard>
  );
};
